import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import Table from '@aytm/app/stats/components/data-views/table/components/Table'
import { calcQuadrantItemsListProps } from '@aytm/app/stats/page/question-views/bpm/components/quadrant/lib/table-utils'

const QuadrantTable = ({
  id,
  answer,
  questionVariants,
  batches,
  chartLegendMode,
  colorGradient,
  defaultValues,
  quadrantBrandsValue,
  quadrantXAxisValue,
  quadrantYAxisValue,
  quadrantRadiusValue,
  quadrantColorValue,
  onModelChange
}) => {
  // port of quadrant items_list onSelectPoint: single-brand toggle against defaults
  const onSelectPoint = position => {
    const single = [String(position)]
    const isSame = 1 === quadrantBrandsValue.length && quadrantBrandsValue[0] === single[0]

    onModelChange({ quadrantBrandsValue: isSame ? defaultValues.q.b : single })
  }

  const { cols, rows } = calcQuadrantItemsListProps({
    id,
    answer,
    questionVariants,
    batches,
    quadrantBrandsValue,
    quadrantXAxisValue,
    quadrantYAxisValue,
    quadrantRadiusValue,
    quadrantColorValue,
    chartLegendMode,
    colorGradient,
    onSelectPoint
  })

  return <Table cols={cols} rows={rows} />
}

QuadrantTable.displayName = 'BpmQuadrantTable'

QuadrantTable.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  answer: answerPropType,
  questionVariants: PropTypes.array,
  batches: PropTypes.array,
  chartLegendMode: PropTypes.string,
  colorGradient: PropTypes.func,
  defaultValues: PropTypes.object,
  quadrantBrandsValue: PropTypes.array,
  quadrantXAxisValue: PropTypes.string,
  quadrantYAxisValue: PropTypes.string,
  quadrantRadiusValue: PropTypes.string,
  quadrantColorValue: PropTypes.string,
  onModelChange: PropTypes.func
}

export default QuadrantTable
